/**
 * Utility functions for content handling and validation
 */

/**
 * Convert content to string format
 * Handles various content types (string, object with text/message/content properties)
 * @param {*} content - The content to convert
 * @returns {string} - The content as a string
 */
export const contentToString = (content) => {
  if (content === null || content === undefined) return '';
  if (typeof content === 'string') return content;
  
  try {
    if (typeof content === 'object') {
      if (content.text) return String(content.text);
      if (content.message) return String(content.message);
      if (content.content) return String(content.content);
      return JSON.stringify(content);
    }
    return String(content);
  } catch (e) {
    return '';
  }
};

/**
 * Check if content is valid (imported from Renderers)
 * TODO: Import from './Renderers' once that's refactored
 * @param {*} content - The content to validate
 * @returns {boolean} - Whether the content is valid
 */
export const isValidContent = (content) => {
  // This will be imported from Renderers once refactored
  // For now, basic validation
  return content !== null && content !== undefined && content !== '';
};